import { IconName } from "PFTheme/graphics/icons";
import { useTranslation } from "react-i18next";

import { ActionIconData } from "../action_icons";

export type UseInputIconsOptions = {
  onClear?: VoidFunction;
  onRestore?: VoidFunction;
  label?: string;
  restoreLabel?: string;
  disabled?: boolean;
  locked?: boolean;
  onMouseDown?: (event: React.MouseEvent<SVGElement>) => void;
};

export const useInputIcons = ({
  onRestore,
  onClear,
  label,
  restoreLabel,
  disabled,
  locked,
  onMouseDown
}: UseInputIconsOptions): ActionIconData[] => {
  const { t } = useTranslation();

  const icons = [
    {
      name: "history" as IconName,
      onClick: onRestore,
      onMouseDown,
      disabled,
      title: restoreLabel || (label ? t("restoreValue", { label }) : t("restore"))
    },
    {
      name: "filter-clean" as IconName,
      onClick: onClear,
      onMouseDown,
      disabled,
      title: label ? t("clearValue", { label }) : t("clear")
    }
  ];

  return icons.filter(({ onClick }) => !locked && !!onClick) as ActionIconData[];
};
